import { Button, SiteNav } from "@motley/design"
import { Link } from "@tanstack/react-router"
import { hasStories } from "./stories"
import { ButtonLink } from "@/base"
import { useAuth } from "@/auth"
import { AppLogo } from "@/ui"

function NavLinks() {
  const { isAuthenticated } = useAuth()

  const ctaProps = isAuthenticated
    ? { to: "/dashboard" as const, children: "Dashboard" }
    : { to: "/auth" as const, children: "Start Free" }

  return (
    <>
      <ButtonLink to="/" hash="features" variant="ghost">
        Features
      </ButtonLink>
      <ButtonLink to="/pricing" variant="ghost">
        Pricing
      </ButtonLink>
      {hasStories() && (
        <ButtonLink to="/stories" variant="ghost">
          Stories
        </ButtonLink>
      )}
      <Button
        variant="ghost"
        nativeButton={false}
        render={
          <a
            href="https://docs.promptjuggler.com/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Docs
          </a>
        }
      />
      {!isAuthenticated && (
        <ButtonLink variant="ghost" to="/auth/login">
          Sign In
        </ButtonLink>
      )}
      <ButtonLink variant="spark" className="ml-2" {...ctaProps} />
    </>
  )
}

/**
 * The bar itself lives in the design system; this supplies the two things it
 * deliberately does not know about — our logo and our router.
 */
export default function Nav() {
  return (
    <SiteNav
      brand={
        <Link to="/">
          <AppLogo size={28} className="my-1" />
        </Link>
      }
      links={<NavLinks />}
    />
  )
}
